(function(angular){
	'use strict';

	angular
		.module('apiModule')
		.factory('EnumFactory', [
			'urlFactory',
			EnumFactoryFunction
		]);

	function EnumFactoryFunction(
		urlFactory
	) {
		var factory = {
			countries: {
				get: getCountries
			},
			relationships: {
				get: getRelationships
			},
			states: {
				get: getStates
			}
		};

		return factory;

		function getCountries() {
			return urlFactory.apiGetPromise("/api/countries")
				.then(function(response) {
					var countries = [];
					response.data.forEach(function (country) {
						countries.push({
							label: country.displayValue,
							value: country.code
						});

					});

					return countries;
				})
				.catch(function(response) {
					urlFactory.handleFailedRequest(response);
				});
		}

		function getStates(countryCode) {
			return urlFactory.apiGetPromise("/api/countries/" + countryCode + "/state")
				.then(function(response) {
					return response.data;
				})
				.catch(function(response) {
					urlFactory.handleFailedRequest(response);
				});
		}

		function getRelationships() {
			return urlFactory.apiGetPromise("/api/beneficiary/relationships")
				.then(function(response) {
					return response.data;
				})
				.catch(function(response) {
					urlFactory.handleFailedRequest(response);
				});
		}
	}
})(window.angular);